module.exports = __webpack_public_path__ + "fa-solid-900.svg?37bc7099f6f1ba80236164f22e905837";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/webfonts/fa-solid-900.svg
// module id = 1459
// module chunks = 0